import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-10 flex flex-col items-center" }
const _hoisted_2 = {
  ref: "canvas",
  width: "1920",
  height: "1080",
  style: {"width":"90vw","height":"auto"}
}

import { pb } from "@/pocketbase";
import { getTechnologyCategoryLabelForTechnologyType, getTechnologyTypeLabel, Product, ProductTechnology, Technology, technologyTypesByCategory } from "@/model";
import { useRoute } from "vue-router";
import { computed, onMounted, Ref, ref, useTemplateRef } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'BusinessUnitProductPrintView',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();

const product: Ref<Product> = ref();
const productTechnologies: Ref<ProductTechnology[]> = ref([]);

async function loadData() {
  product.value = await pb.collection('products').getOne<Product>(route.params.id, {
    expand: 'businessUnit',
    sort: 'name',
    '$autoCancel': false,
  });

  productTechnologies.value = await pb.collection('product_technologies').getFullList<ProductTechnology>(null, {
    expand: 'technology',
    sort: 'technology.name',
    filter: `product = '${product.value.id}'`,
    '$autoCancel': false,
  });
}

;(
  ([__temp,__restore] = _withAsyncContext(() => loadData())),
  await __temp,
  __restore()
);

const categories = computed(() => {
  const categories: Record<string, {
    label: string,
    types: Record<string, {
      label: string,
      productTechnologies: ProductTechnology[],
    }>,
  }> = {};

  for (const productTechnology of productTechnologies.value) {
    const technology = productTechnology.expand!.technology!;
    const categoryLabel = getTechnologyCategoryLabelForTechnologyType(technology.type);
    const typeLabel = getTechnologyTypeLabel(technology.type);

    if (!categories[categoryLabel]) {
      categories[categoryLabel] = {
        label: categoryLabel,
        types: {},
      };
    }

    if (!categories[categoryLabel].types[typeLabel]) {
      categories[categoryLabel].types[typeLabel] = {
        label: typeLabel,
        productTechnologies: [],
      };
    }

    categories[categoryLabel].types[typeLabel].productTechnologies.push(productTechnology);
  }

  return Object.values(categories).sort((a, b) => {
    // sort categories
    const a1 = technologyTypesByCategory.indexOf(technologyTypesByCategory.find(({ category }) => category === a.label));
    const b1 = technologyTypesByCategory.indexOf(technologyTypesByCategory.find(({ category }) => category === b.label));

    return a1 - b1;
  }).map(category => {
    // and sort types in each category
    const sortedTypes = technologyTypesByCategory.find(({ category: cat }) => cat === category.label).types;

    return {
      ...category,
      types: Object.values(category.types).sort((a, b) => {
        return sortedTypes.indexOf(a.label) - sortedTypes.indexOf(b.label);
      }),
    };
  });
});

function getLogoUrl(technology: Technology): string {
  return pb.files.getUrl(technology, technology.logo);
}

const canvasRef = useTemplateRef<HTMLCanvasElement>('canvas');
onMounted(() => {
  const canvas = canvasRef.value;
  let ctx = canvas.getContext('2d');
  ctx.fillStyle = '#404040';
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  let fontWeight = 500;
  let fontSize = 20;
  let fontColor = '#fff';

  const changeFont = (opts: { weight?: number, size?: number, color?: string } = {}) => {
    if (opts.weight) {
      fontWeight = opts.weight;
    }
    if (opts.size) {
      fontSize = opts.size;
    }
    if (opts.color) {
      fontColor = opts.color;
    }

    ctx.font = `${fontWeight} ${fontSize}px Arial`;
    ctx.fillStyle = fontColor;
    ctx.textBaseline = 'top';
  }
  changeFont();

  const breakString = (text: string, maxWidth: number): string[] => {
    const words = text.split(' ');
    const lines = [];
    for (const word of words) {
      if (lines.length === 0) {
        lines.push(word);
        continue;
      }

      const lineWidth = ctx.measureText(lines[lines.length - 1] + ' ' + word).width;
      if (lineWidth > maxWidth) {
        lines.push(word);
      } else {
        lines[lines.length - 1] += ' ' + word;
      }
    }

    return lines;
  };

  const drawImage = (url, x, y, h, w) => {
    const image = new Image();
    image.src = url;
    image.onload = () => {
      ctx.drawImage(image, x, y, w, h);
    };
  }

  const padding = 20;

  let x = padding;
  let y = padding;

  changeFont({ weight: 700, size: 28 });
  ctx.fillText(product.value.name + ' (' + product.value.expand?.businessUnit?.name + `) Tech Stack`, x, y);
  y += fontSize + 40;

  const categoryY = y;
  const innerWidth = 1920 - 2 * padding;
  const numColumns = categories.value.length;
  const columnWidth = Math.floor(innerWidth / numColumns);

  categories.value.forEach(category => {
    changeFont({ weight: 700, size: 20, color: '#666' });
    const lines = breakString(category.label.toUpperCase(), columnWidth - 50);
    for (const line of lines) {
      ctx.fillText(line, x, y);
      y += fontSize + 10;
    }
    y += fontSize + 10;

    category.types.forEach(type => {
      /*changeFont({ weight: 500, size: 16, color: '#aaa' });
      const lines = breakString(type.label.toUpperCase(), columnWidth - 50);
      for (const line of lines) {
        ctx.fillText(line, x, y);
        y += fontSize + 5;
      }
      y += fontSize + 5;*/

      type.productTechnologies.forEach(productTech => {
        const technology = productTech.expand!.technology!;
        const label = technology.name + ' ' + productTech.version;
        const labelXOffset = 65;

        /*if (technology.simpleicon) {
          drawImage(`https://cdn.simpleicons.org/${technology.simpleicon}`, x, y, 50, 50);
        } else if (technology.logo) {
          drawImage(getLogoUrl(technology), x, y, 50, 50);
        } else {*/
          ctx.fillStyle = '#11111122';
          ctx.fillRect(x, y, 50, 50);
        //}
        x += labelXOffset;

        changeFont({ weight: 500, size: 18, color: '#fff' });
        const lines = breakString(label, columnWidth - 150);
        y += Math.floor(18 / lines.length);
        for (const line of lines) {
          ctx.fillText(line, x, y);
          y += fontSize + 2;
        }

        y += 20;
        x -= labelXOffset;
      });

      //y += 30;
    });

    x += columnWidth;
    y = categoryY;
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("p", { class: "mb-4" }, "Right click on the image and choose \"Save image as ...\"", -1)),
    _createElementVNode("canvas", _hoisted_2, null, 512)
  ]))
}
}

})